import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"
import { ConfirmModal } from "./ConfirmModal"

type DeleteConfirmDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    typeOfEntity: string
    entityName: string
    handleClick: () => void
}>

export function DeleteConfirmDialog({
    open,
    onClose,
    typeOfEntity,
    entityName,
    handleClick,
}: DeleteConfirmDialogProps) {
    const { l10n } = useAppLocalization()
    return (
        <ConfirmModal
            open={open}
            onClose={onClose}
            title={
                <LocalizedStrict
                    id="delete-confirm-modal-title"
                    vars={{
                        itemType: typeOfEntity,
                    }}
                >
                    <span>Delete</span>
                </LocalizedStrict>
            }
            message={
                <LocalizedStrict
                    id="delete-confirm-modal-question"
                    vars={{
                        itemName: entityName,
                    }}
                >
                    <>{`Are you sure you want to delete ${entityName}?`}</>
                </LocalizedStrict>
            }
            handleClick={handleClick}
            buttonLabelSubmit={l10n.getString("delete-confirm-modal-button-delete")}
        />
    )
}
